import _always from "ramda/es/always";
import _head from "ramda/es/head";
import _tryCatch from "ramda/es/tryCatch";
export default _tryCatch(_head, _always(undefined));